import { StandardSwitch } from '@brandfolder/react';
import React, { FunctionComponent, useState } from 'react';
import styled from 'styled-components';

import { Pagination } from '../common/Pagination';
import { Brandfolder, Organization } from '../customPeopleTagTypes';
import { usePeoplePageSearchState } from '../hooks/usePeoplePageQueryState';
import '../styles/home.scss';

import { EmptyState } from './EmptyState';
import { FaceCard } from './FaceCard';

import { PeoplePageActionsBar } from './PeoplePageActionsBar';
import { PeoplePageHeader } from './PeoplePageHeader';

interface HomeProps {
  brandfolder: Brandfolder;
  organization: Organization;
  orgApiKey: string;
}

export interface MockFaceCard {
  id: string;
  imageUrl: string;
  label?: string;
}
const mockImageUrl =
  'https://cdn-staging.bfldr.com/8YE6MLLB/at/3wrsttmjrvcfprbn6t6q3bn/photo_15.png?auto=webp&format=png';

export const mockFaceCardData: MockFaceCard[] = [
  {
    id: 'fc-1',
    imageUrl: mockImageUrl,
    label: ''
  },

  {
    id: 'fc-2',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/988rm26xt6ph3xx7gf7tq8g/photo_8.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-3',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/c4w78hmp3hsxnrn73htntg/photo_9.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-4',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/6p3cpcpp56sqmgz4kkjj93/photo_7.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-5',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/gs2h75ht6j43p8hqsf9f4jk/photo_6.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-6',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/2g845s7x48x8vph3q7x723/photo_5.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-7',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/jsgkwfmjgmwf4qrj7jtbwsh/photo_4.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-8',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/632r5fpg5w4m97gcn44z5vmv/photo_3.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-9',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/tw9ts6tjrnksj4h9mnw4m47/photo_17.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-12',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/x3pj964mjbjq3rqjxnffq9x8/photo_14.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-13',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/mwp6xnf3ctmntcf4r3wmcm/photo_11.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-14',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/gk7pprpnvhjkkrvwftb66xqh/photo_10.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-15',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/rwkqx4tqc4mppj53g3mnh9hq/photo_2.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-16',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/gm4xkj55888rfzhsgf7pvn2n/photo.png?auto=webp&format=png',
    label: ''
  },
  {
    id: 'fc-10',
    label: 'Sarah has a very very very long name',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/s68zc3rjnb4s3nmzx9qnckqz/photo_1.png?auto=webp&format=png'
  },
  {
    id: 'fc-11',
    label: 'Jane Doe',
    imageUrl: 'https://cdn-staging.bfldr.com/8YE6MLLB/at/482mv32fqrsfc7nt8njs8k4/photo_12.png?auto=webp&format=png'
  },
];

const mockPeopleResponse = {
  data: mockFaceCardData,
  included: {
    total: 501,
  }
};

const PeoplePageWrapper = styled.div`
  margin: 40px auto;
  max-width: 1608px;
  width: 93%;

  .bf-switch__standard {
    float: right;
  }
`;

const PeopleTagsFaceCardsWrapper = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(1, 100%);
  justify-content: center;
  
  @media (min-width: 320px) {
    grid-template-columns: repeat(2, 48%);
  }
  @media (min-width: 744px) {
    grid-template-columns: repeat(3, minmax(166px, 1fr));
  }
  @media (min-width: 900px) {
    grid-template-columns: repeat(4, minmax(194px, 1fr));
  }
  @media (min-width: 1320px) {
    grid-template-columns: repeat(5, minmax(229px, 1fr));
  }
  @media (min-width: 1526px) {
    grid-template-columns: repeat(6, minmax(15%, 1fr));
  }
  @media (min-width: 1728px) {
    grid-template-columns: repeat(7, minmax(210px, 1fr));
  }
`;

export const Home: FunctionComponent<HomeProps> = () => {
  // temporary state to toggle mock data
  const [useMockData, setUseMockData] = useState(true);
  const [state, setState] = usePeoplePageSearchState();
  const mockPeopleData = useMockData ? mockPeopleResponse.data : [];
  const hasTaggedFaces = mockPeopleData.some((fc) => !!fc.label);
  const perPage = 150;

  return (
    <PeoplePageWrapper>
      {/* temporary switch to toggle mock data */}
      <StandardSwitch
        id="data-no-data-switch"
        isChecked={useMockData}
        onChange={(): void => setUseMockData(!useMockData)}
      >
        Use mock data
      </StandardSwitch>
      <PeoplePageHeader />
      <PeoplePageActionsBar hasTaggedFaces={hasTaggedFaces} />
      <Pagination
        page={Number(state.page) || 1}
        perPage={perPage}
        setPage={setState}
        /* will need to clean this up when we have real data */
        total={useMockData ? mockPeopleResponse.included.total : 0}
      />
      <PeopleTagsFaceCardsWrapper>
        {mockPeopleData.map((faceCard) => (
          <FaceCard
            key={faceCard.id}
            id={faceCard.id}
            imageUrl={faceCard.imageUrl || mockImageUrl}
            label={faceCard.label}
          />
        ))}
      </PeopleTagsFaceCardsWrapper>
      {!mockPeopleData.length && <EmptyState />}
    </PeoplePageWrapper>
  );
};
